/* src/app/components/ai-assist/bot-suggestion/bot-suggestion.component.scss */
/*# sourceMappingURL=bot-suggestion.component.css.map */
